/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react';
import { Control } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { LOFormFieldValues } from '@/domain/job-application/types';
import { useLoginUrl } from '@/hooks';

import { useDisableAdditionalComments, useShowAdditionalDocs } from '../../contexts';
import {
  CommentsField,
  CountryCodeField,
  CvDocumentUploadField,
  EmailField,
  NameField,
  OtherDocumentsUploadField,
  PhoneField,
} from '../form-fields';

import * as S from '@/domain/job-application/job-application.common.styles';

type Props = {
  control: Control<LOFormFieldValues>;
  updateUploadDocsHandler: (value: string, field: 'cvDoc' | 'otherDocs') => void;
};

export const LoggedOutApplyForm: React.VFC<Props> = ({ control, updateUploadDocsHandler }) => {
  const loginUrl = useLoginUrl();
  const isAdditionalCommentsDisabled = useDisableAdditionalComments();
  const showAdditionalDocs = useShowAdditionalDocs();

  return (
    <>
      <S.Section>
        <S.SectionHeadline size="large">
          <FormattedMessage id="JOBS_POSTING_APPLY_FORM_LO_INFO_SECTION_HEADLINE" />
        </S.SectionHeadline>
        <S.FormFieldWrapperReactive>
          <S.FirstFieldWrapperReactive>
            <NameField control={control} name="firstName" />
          </S.FirstFieldWrapperReactive>
          <S.LastFieldWrapperReactive>
            <NameField control={control} name="lastName" />
          </S.LastFieldWrapperReactive>
        </S.FormFieldWrapperReactive>
        <EmailField
          // @ts-ignore
          control={control}
        />
        <S.LogInLinkBodyCopy size="small">
          <FormattedMessage
            id="JOBS_POSTING_APPLY_FORM_LO_LOG_IN_TEXT"
            values={{
              a: (chunks) => <a href={loginUrl}>{chunks}</a>,
            }}
          />
        </S.LogInLinkBodyCopy>
      </S.Section>
      <S.Section>
        <S.SectionHeadline size="large">
          <FormattedMessage id="JOBS_POSTING_APPLY_FORM_LO_CONTACT_SECTION_HEADLINE" />
        </S.SectionHeadline>
        <S.FormFieldWrapper>
          <S.FirstFieldWrapper>
            <CountryCodeField
              // @ts-ignore
              control={control}
            />
          </S.FirstFieldWrapper>
          <S.LastFieldWrapper>
            <PhoneField
              // @ts-ignore
              control={control}
            />
          </S.LastFieldWrapper>
        </S.FormFieldWrapper>
      </S.Section>
      <CvDocumentUploadField
        // @ts-ignore
        control={control}
        isRequired
        updateValue={updateUploadDocsHandler}
      />
      {showAdditionalDocs ? (
        <OtherDocumentsUploadField
          // @ts-ignore
          control={control}
          updateValue={updateUploadDocsHandler}
        />
      ) : null}
      {isAdditionalCommentsDisabled ? null : (
        <S.Section>
          <S.CommentsSectionHeadline size="large">
            <FormattedMessage id="JOBS_POSTING_EASY_APPLY_FORM_ADDITIONAL_COMMENTS_HEADLINE" />
          </S.CommentsSectionHeadline>
          <S.CommentsBodyCopy size="medium" lineHeight="dense">
            <FormattedMessage id="JOBS_POSTING_EASY_APPLY_FORM_ADDITIONAL_COMMENTS_BODY" />
          </S.CommentsBodyCopy>
          <CommentsField
            // @ts-ignore
            control={control}
          />
        </S.Section>
      )}
    </>
  );
};
